<template>
    <div class="d-flex justify-content-center">
        <span class="mr-2">{{ 'draw_is_running'| lang }}</span>
        <b-progress v-if="indefinite" :value="100" :max="100" variant="success" animated></b-progress>
        <b-progress v-else :value="passed" :max="estimated" variant="success"></b-progress>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { head } from 'lodash';
import moment from 'moment';

export default {
    props: ['gameId'],

    computed: {
        ...mapState(['datetime', 'channels']),

        game() {
            return Config.games[this.gameId];
        },

        remaining() {
            const channel = this.channels[this.game.channel_id];

            if(channel) {
                const unfinshedDraws = channel.draws.unfinished_list;

                if (unfinshedDraws.length) {
                    const from = moment(this.datetime)
                    const to = moment(head(unfinshedDraws).datetime);

                    return to.diff(from, 'seconds');
                }
            }

            const remainingNext = this.$store.getters.remaining(this.game.channel_id);

            return remainingNext;
        },

        indefinite() {
            const beforeBuffer = this.game.allow_tickets_before;

            if (this.remaining - beforeBuffer > 0 || this.passed > this.estimated) {
                return true;
            }

            return false;
        },

        passed() {
            const beforeBuffer = this.game.allow_tickets_before;

            return Math.abs(this.remaining - beforeBuffer);
        },

        estimated() {
            const maxDuration = this.game.studio_max_duration;
            const hasPools = Object.values(this.game.pools).length > 0;

            if (hasPools) {
                return maxDuration / 4 * 6;
            }

            return maxDuration / 4 * 3;
        },
    },
}
</script>